"use client";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PoweredBy({ className = "" }) {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  return (
    <p
      className={` text-xs tracking-tight font-semibold inline-flex items-center gap-1 py-1 px-2 rounded-lg bg-white text-black uppercase ${className}`}
    >
      <>
        {pathname.includes("/hi/") || pathname.includes("/ar/") ? (
          <>
            {t("poweredBy")}{" "}
            <img src="assets/logos/AI&.jpg" width={42} height={24} alt="AI&" className="mb-1" />
          </>
        ) : (
          <>
            {t("poweredByAI&")}
            <img src="assets/logos/AI&.jpg" width={42} height={24} alt="AI&" className="mb-1"/>{" "}
          </>
        )}
      </>
    </p>
  );
}
